/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAaaB2COrderHistoryData } from './aaa_b2c_order_history.data';
import { IAaa_b2c_order_historyProps } from './aaa_b2c_order_history.props.autogenerated';
import { getRequestOrderHistoryB2CAsync } from '../../dataActions/DataActionExtension.g';
import _ from 'lodash';

export interface IAaa_b2c_order_historyViewProps extends IAaa_b2c_order_historyProps<IAaaB2COrderHistoryData> {
    requestOrderLines: [];
    currentPageItems: [];
    headers: [];
    totalItemPerPage: number;
    activePage: number;
    pageCount: number;
    handlePageItemsChange: any;
    handleMouseEnterEvent: any;
    handleMouseOutEvent: any;
    mouseOverIndex: number;
    handleOnChangeInput: any;
    getOrderDetailPageUrl: any;
    searchItems: any;
    resetItems: any;
    searchString: string;
    searchPageItems: [];
    isLoading: boolean;
}
export interface IAaa_b2c_order_historyState {
    requestOrderLines: [];
    currentPageItems: [];
    headers: any;
    customerInfo: { AccountNumber: '' };
    products: [];
    totalItemPerPage: number;
    activePage: number;
    pageCount: number;
    mouseOverIndex: number;
    searchString: string;
    searchPageItems: [];
    isLoading: boolean;
}

/**
 *
 * Aaa_b2c_order_history component
 * @extends {React.PureComponent<IAaa_b2c_order_historyProps<IAaaB2COrderHistoryData>>}
 */
class Aaa_b2c_order_history extends React.PureComponent<IAaa_b2c_order_historyProps<IAaaB2COrderHistoryData>, IAaa_b2c_order_historyState> {
    constructor(props: any) {
        super(props);
        this.state = {
            requestOrderLines: [],
            currentPageItems: [],
            headers: ['Stockist Name', 'Order Number', 'Individual Price', 'Total Price', 'Snapshot ID', 'Status'],
            customerInfo: { AccountNumber: '' },
            products: [],
            totalItemPerPage: this.props.config.totalItemPerPage ? this.props.config.totalItemPerPage : 0,
            activePage: 1,
            pageCount: 0,
            mouseOverIndex: 0,
            searchString: '',
            searchPageItems: [],
            isLoading: true
        };
    }

    public async componentDidMount(): Promise<void> {
        if (this.props.data.customerInformation.result) {
            const customerInfo = this.props.data.customerInformation.result;
            await this.getRequestOrderList(customerInfo);
        }
    }

    public getRequestOrderList = async (customerInfo: any) => {
        const response: any = await getRequestOrderHistoryB2CAsync(
            {
                callerContext: this.props.context.actionContext,

                queryResultSettings: {}
            },
            ''
        );

        if (response.RequestOrder) {
            this.mappedRequestOrder(response.RequestOrder, customerInfo);
        }
    };
    public mappedRequestOrder(requestOrders: any, customerInfo: any) {
        const mappedProducts: any = [];
        for (const requestOrder of requestOrders) {
            if (requestOrder.RequestOrderId) {
                requestOrder.imageUrl = requestOrder.LowResImageURL;
                requestOrder.stockistName = requestOrder.b2BCUSTOMERNAME ? requestOrder.b2BCUSTOMERNAME : '-';
                requestOrder.orderNumber = requestOrder.RequestOrderId;
                requestOrder.totalPrice = `$${requestOrder.B2CPrice.toLocaleString()}`;
                requestOrder.orderLinesPriceInfo = [];
                const parseData = JSON.parse(requestOrder.RequestOrderLines);
                _.forEach(parseData, (orderLine: any) => {
                    requestOrder.orderLinesPriceInfo.push({ name: orderLine.DetailName, price: orderLine.B2CPrice });
                });
                requestOrder.snapShotId = requestOrder.Snapshotid;
                requestOrder.statusName = requestOrder.StatusName;
                requestOrder.lineNum = requestOrder.LineNum.toString();
                mappedProducts.push(requestOrder);
            }
        }
        // if manage orders length > 0 set active 1 per page 5,
        // divided mangage orders / per page 50/5=10 pagaes
        // if active is 1 page pick  0 to active -1 and push into cureent page items
        const currentPageItems = this.currentPageItems(this.state.activePage, this.state.totalItemPerPage, mappedProducts);
        this.setState({
            requestOrderLines: mappedProducts,
            customerInfo: customerInfo,
            currentPageItems: currentPageItems,
            isLoading: false,
            pageCount:
                mappedProducts.length <= this.state.totalItemPerPage ? 1 : Math.ceil(mappedProducts.length / this.state.totalItemPerPage)
        });
    }

    private handleMouseEnterEvent = (index: number) => {
        this.setState({ mouseOverIndex: index });
    };
    private handleMouseOutEvent = () => {
        this.setState({ mouseOverIndex: 0 });
    };
    private handlePageItemsChange = (totalItemPerPage: any, activePage: number) => {
        let pageCount: number;
        let currentPageItems: any;
        if (this.state.searchPageItems.length > 0) {
            pageCount =
                this.state.searchPageItems.length <= totalItemPerPage ? 1 : Math.ceil(this.state.searchPageItems.length / totalItemPerPage);
            currentPageItems = this.currentPageItems(activePage, totalItemPerPage, this.state.searchPageItems);
        } else {
            pageCount =
                this.state.requestOrderLines.length <= totalItemPerPage
                    ? 1
                    : Math.ceil(this.state.requestOrderLines.length / totalItemPerPage);
            currentPageItems = this.currentPageItems(activePage, totalItemPerPage, this.state.requestOrderLines);
        }
        this.setState({ pageCount, totalItemPerPage, activePage, currentPageItems });
    };
    private currentPageItems = (activePage: number, totalItemPerPage: number, requestOrderLines: any) => {
        const getEndOrderIndexInPage = activePage * totalItemPerPage - 1;
        let getStartOrderIndexInPage = getEndOrderIndexInPage - totalItemPerPage + 1;
        const currentPageItems: any = [];
        if (getEndOrderIndexInPage && getEndOrderIndexInPage) {
            for (getStartOrderIndexInPage; getStartOrderIndexInPage <= getEndOrderIndexInPage; getStartOrderIndexInPage++) {
                if (requestOrderLines[getStartOrderIndexInPage]) {
                    currentPageItems.push(requestOrderLines[getStartOrderIndexInPage]);
                }
            }
        }
        return currentPageItems;
    };
    private handleOnChangeInput = (searchString: string) => {
        this.setState({ searchString: searchString.toLowerCase() });
    };
    private getOrderDetailPageUrl = (requestId: string, lineNum: number) => {
        const request = this.props.context.request;
        let orderDetailUrl = request.url.requestUrl.origin;
        if (request.sitePath) {
            orderDetailUrl = orderDetailUrl + request.sitePath;
        }
        if (requestId && request) {
            window.location.href = `${orderDetailUrl}${this.props.config.redirectToOrderDetailUrl}?requestOrderId=${requestId}&lineNum=${lineNum}`;
        }
    };
    private searchItems = () => {
        if (this.state.searchString) {
            const searchPageItems: any = this.state.requestOrderLines.filter((f: any) => {
                return f.b2BCUSTOMERNAME.toLowerCase().includes(this.state.searchString);
            });
            console.log(searchPageItems);
            const currentPageItems = this.currentPageItems(1, this.state.totalItemPerPage, searchPageItems);
            this.setState({
                activePage: 1,
                searchPageItems,
                currentPageItems: currentPageItems,
                pageCount:
                    searchPageItems.length <= this.state.totalItemPerPage
                        ? 1
                        : Math.ceil(searchPageItems.length / this.state.totalItemPerPage)
            });
        }
    };
    private resetItems = () => {
        const currentPageItems = this.currentPageItems(1, this.state.totalItemPerPage, this.state.requestOrderLines);
        this.setState({
            searchPageItems: [],
            searchString: '',
            currentPageItems,
            activePage: this.state.activePage,
            pageCount:
                this.state.requestOrderLines.length <= this.state.totalItemPerPage
                    ? 1
                    : Math.ceil(this.state.requestOrderLines.length / this.state.totalItemPerPage)
        });
    };
    public render(): JSX.Element | null {
        if (!this.state.customerInfo) {
            return null;
        }
        const viewProps: IAaa_b2c_order_historyViewProps = {
            ...(this.props as IAaa_b2c_order_historyProps<IAaaB2COrderHistoryData>),
            requestOrderLines: this.state.requestOrderLines,
            headers: this.state.headers,
            activePage: this.state.activePage,
            totalItemPerPage: this.state.totalItemPerPage,
            currentPageItems: this.state.currentPageItems,
            pageCount: this.state.pageCount,
            handlePageItemsChange: this.handlePageItemsChange,
            handleMouseEnterEvent: this.handleMouseEnterEvent,
            handleMouseOutEvent: this.handleMouseOutEvent,
            mouseOverIndex: this.state.mouseOverIndex,
            handleOnChangeInput: this.handleOnChangeInput,
            getOrderDetailPageUrl: this.getOrderDetailPageUrl,
            searchItems: this.searchItems,
            resetItems: this.resetItems,
            searchString: this.state.searchString,
            searchPageItems: this.state.searchPageItems,
            isLoading: this.state.isLoading
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default Aaa_b2c_order_history;
